<template>
  <auth-page-wrapper container-class="winners">
    <section>
      <h1>{{ getTranslations.winners_page_title }}</h1>

      <p class="title_tag">{{ getTranslations.winners_page_title_tag }}</p>
    </section>

    <winners-prize-list-item
      v-for="prize in prizeList"
      :key="prize.type"
      :type="prize.type"
      :user-list="prize.userList"
      :last-update-date="prize.lastUpdateDate"
      :container-class="prize.containerClass"
    ></winners-prize-list-item>
  </auth-page-wrapper>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import AuthPageWrapper from './common/wrapper/AuthPageWrapper'
import WinnersPrizeListItem from './WinnersPrizeListItem'

export default {
  name: 'winners',
  components: {
    AuthPageWrapper,
    WinnersPrizeListItem
  },
  computed: {
    ...mapState('profile', [
      'allWinners'
    ]),
    ...mapGetters('profile', [
      'getAvailablePrizeTypes'
    ]),
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    prizeList () {
      const prizesPerType = {GRAND: {userList: []}, MONTHLY: {userList: []}, WEEKLY: {userList: []}, DAILY: {userList: []}}

      if (Array.isArray(this.allWinners) && (this.allWinners.length > 0)) {
        this.allWinners.forEach(({prizeDTO, userDTO, localDateTime}) => {
          if (prizeDTO && prizesPerType[prizeDTO.type]) {
            prizesPerType[prizeDTO.type].userList.push({
              msisdn: userDTO ? userDTO.msisdn : '',
              username: userDTO ? userDTO.username : '',
              avatar: userDTO ? userDTO.avatar : '',
              hasPrivateProfile: userDTO ? userDTO.hasPrivateProfile : undefined,
              isWebUser: userDTO ? userDTO.webUser : undefined,
              rewardDescription: userDTO ? prizeDTO.headline : '',
              rewardDate: localDateTime
            })
          }
        })
      }

      const availablePrizeTypeList = Array.isArray(this.getAvailablePrizeTypes) ? this.getAvailablePrizeTypes : []
      const lastUpdateDate = new Date()

      return Object.entries(prizesPerType)
        .filter(([type, {userList}]) => availablePrizeTypeList.includes(type) || userList.length > 0)
        .map(([type, {userList}]) => ({
          type,
          userList,
          lastUpdateDate,
          containerClass: ({GRAND: 'grand_prize', WEEKLY: 'grand_prize', MONTHLY: 'weekly_prize', DAILY: ''}[type] || '')
        }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Winners.vue